import packagejson from '../../package.json'
const PACKAGEJSON_DEFAULT_KEYS = [
  'name',
  'description',
  'version'
]


export function getKeys(keys?: string[]): {
  name?: string
  description?: string
  version?: string
} {
  const info: {[key: string]: string} = {}
  if (keys) {
    for (const key of keys) {
      // @ts-ignore
      const item = packagejson[key]
      if (item) {
        info[key] = item
      }
    }
  } else {
    for (const key of PACKAGEJSON_DEFAULT_KEYS) {
      // @ts-ignore
      const item = packagejson[key]
      if (item) {
        info[key] = item
      }
    }
  }
  return info
}

export default {getKeys}